import SectionHelp from '../templates/SectionHelp.mdx';
import ExampleDeleteButton from '../example-buttons/ExampleDeleteButton.vue';
import ExampleCloseButton from '../example-buttons/ExampleCloseButton.vue';

export function EditButton() {
  return (
    <v-btn
      color="warning"
      variant="outlined">
      Edit
    </v-btn>
  );
}

# User Configuration

This is where you can add, edit or delete users.

<SectionHelp />

## Adding Users

Click the <v-btn color='primary'>ADD</v-btn> button (bottom right). The Create User menu appears.

Fill in the below fields:

- **Username** - needs to be unique, and not currently used on CanvasPro
- **Password** - take note of the password requirement
- **Email** - needs to be a unique email not currently used on CanvasPro

Select the **Role** required, the defaults that come with CanvasPro are:

- **Admin** - The admin user has full permissions and control over the system
- **Network Manager** - The Network Manager role has the ability to configure the system but not the content
- **Content Manager** - The Content Manager role has the ability to configure assets, templates and channels
- **App** - The app role can only access endpoints related to apps

However, feel free to add more roles and their permissions in the **User Roles** section below.

## Editing Users

Click <EditButton /> for more help click the help button within that menu.

## Deleting Users

Click <ExampleDeleteButton />, a menu will pop up asking you to confirm your choice.

If you want to cancel click <ExampleCloseButton /> (top right) else click <v-btn color='error'>DELETE USER</v-btn> to confirm the deletion.
